import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { CustomProvider } from 'rsuite';
import enGB from 'rsuite/locales/en_GB';
import locales from './locales';
import Frame from './components/Frame';
import DashboardPage from './pages/dashboard';
import Error404Page from './pages/authentication/404';
import Error500Page from './pages/authentication/500';
import SignInPage from './pages/authentication/sign-in';
import SignUpPage from './pages/authentication/sign-up';
import MembersPage from './pages/tables/members';
import VirtualizedTablePage from './pages/tables/virtualized';
import FormBasicPage from './pages/forms/basic';
import FormWizardPage from './pages/forms/wizard';
import CalendarPage from './pages/calendar';
import { appNavs } from './config';
import BuyerC from './components/BuyerC';
import Addprduct from './pages/tables/members/Addproduct';
import BulkProduct from './pages/tables/members/BulkProduct';
import Catalogue from './pages/catalogue/Catalogue';
import Selection from './pages/catalogue/Selection';
import EditDetails from './pages/catalogue/EditDetails';
import AddUser from './pages/addpage/AddUser';
import CompanyMaster from './pages/addpage/CompanyMaster';
import AddBuyer from './pages/buyer/AddBuyer';
import ManageCollection from './pages/manageCatalogue/ManageCollection';
import EditCollection from './pages/manageCatalogue/EditCollection';
import ViewCollection from './pages/manageCatalogue/ViewCollection';
import ManageCatalogue from './pages/manageCatalogue/ManageCatalogue';
import Generate from './pages/catalogue/GenerateCata';
import Master from './pages/masters/Master';

const App = () => {
  return (
    <IntlProvider locale="en" messages={locales.en}>
      <CustomProvider locale={enGB}>
        
        <Routes>
          <Route index element={<SignInPage />} />
            <Route path="/" element={<Frame navs={appNavs} />}>
              
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="products" element={<MembersPage />} />
              <Route path="table-virtualized" element={<VirtualizedTablePage />} />
              <Route path="error-404" element={<Error404Page />} />
              <Route path="error-500" element={<Error500Page />} />
              {/* <Route path="sign-in" element={<SignInPage />} /> */}
              <Route path="sign-up" element={<SignUpPage />} />
              <Route path="form-basic" element={<FormBasicPage />} />
              <Route path="form-wizard" element={<FormWizardPage />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="products-create" element={<Addprduct />} />
              <Route path="bulkproduct" element={<BulkProduct />} />
              <Route path="buyer" element={<BuyerC />} />
              <Route path="catalogue" element={<Catalogue />} />
              <Route path="selection" element={<Selection />} />
              <Route path="editDetails" element={<EditDetails />} />
              <Route path="adduser" element={<AddUser />} />
              <Route path="companyMaster" element={<CompanyMaster />} />
              <Route path="addbuyer" element={<AddBuyer />} />
              <Route path="manageCollection" element={<ManageCollection />} />
              <Route path="editCollection" element={<EditCollection />} />
              <Route path="viewCollection" element={<ViewCollection />} />
              <Route path="manageCatalogue" element={<ManageCatalogue />} />
              <Route path="generate-catalogue" element={<Generate />} />
              <Route path="master" element={<Master />} />
            </Route>
            <Route path="*" element={<Error404Page />} />
        </Routes>
        
      </CustomProvider>
    </IntlProvider>
  );
};

export default App;
